import { Injectable } from '@angular/core';
import { CurrencyConversion, LoyaltyCurrency } from '@rd/types';
import { CurrencyConversionResponse } from '@rd/types/currency-conversion.response';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NydusNetworkApiDataService } from '../nydus-network-api-data/nydus-network-api-data.service';

interface HomeCurrencyConversionParams {
  homeCurrencyId: LoyaltyCurrency['id'];
  targetCurrencyId: LoyaltyCurrency['id'];
  redemptionAmount: number;
}

interface TargetCurrencyConversionParams {
  homeCurrencyId: LoyaltyCurrency['id'];
  targetCurrencyId: LoyaltyCurrency['id'];
  transferAmount: number;
}

@Injectable({
  providedIn: 'root',
})
export class CurrencyConversionApiService {
  constructor(private nydusNetworkDataService: NydusNetworkApiDataService) {}

  postCurrencyConversion(
    params: HomeCurrencyConversionParams | TargetCurrencyConversionParams,
  ): Observable<CurrencyConversion> {
    const body: { [key: string]: any } = {
      currencyConversion: {
        homeCurrencyId: params.homeCurrencyId,
        targetCurrencyId: params.targetCurrencyId,
      },
    };

    if ('redemptionAmount' in params) {
      body.currencyConversion.redemptionAmount = params.redemptionAmount;
    } else {
      body.currencyConversion.transferAmount = params.transferAmount;
    }

    return this.nydusNetworkDataService
      .post<CurrencyConversionResponse>('currency_conversions', body)
      .pipe(
        map((response) => {
          return this.transformCurrencyConversionsResponse(response);
        }),
      );
  }

  private transformCurrencyConversionsResponse(
    response: CurrencyConversionResponse,
  ): CurrencyConversion {
    return response.data.attributes;
  }
}
